import { TPublicPropertyReportCreateForm } from "../../../../../domain/codecs/form/PublicPropertyReportForm";
import { doesErrorCodeExist } from "../../../../../shared/src/codecs/errors";

export const propertyReportErrorMessages = (form: TPublicPropertyReportCreateForm): Array<string> => {
    const isRecaptchaError = doesErrorCodeExist("RecaptchaFailed", form.validationErrors);

    const isLandRegistryTitleNotAvailable =
        form.children.response?._tag === "error"
        && (
            form.children.response.code === "not_available_electronically"
            || form.children.response.code === "title_number_invalid"
        );

    const isLandRegistryFaultError =
        form.children.response?._tag === "error"
        && form.children.response.code === "fault";

    const isServiceUnavailableError =
        form.children.response?._tag === "out_of_hours"
        || doesErrorCodeExist("ServiceUnavailable", form.validationErrors);

    const isReportUnavailableError = doesErrorCodeExist("ReportUnavailable", form.validationErrors);

    const isIntroducerNotFoundError = doesErrorCodeExist("IntroducerNotFound", form.validationErrors);

    const isContactDetailsRequiredError = doesErrorCodeExist("ContactDetailsRequired", form.validationErrors);

    const isUnexpectedError = form.status === "failure" || form.status === "notFound";

    return [
        ...(isRecaptchaError ? ["Something went wrong when submitting your request, please refresh the page and try again"] : []),
        ...(isLandRegistryTitleNotAvailable ? ["Land Registry do not hold an electronic copy of the data for this property. Unfortunately we wont be able to generate a Property Report for this address"] : []),
        ...(isLandRegistryFaultError ? ["Land Registry are having difficulties at the moment, please try again later"] : []),
        ...(isServiceUnavailableError ? ["Land Registry's service is currently offline, please try again later"] : []),
        ...(isReportUnavailableError ? ["We couldn't read Land Registry's record for this property. That means we can't make a Property Report for it. Try another address, or get in touch and we'll take a look"] : []),
        ...(isIntroducerNotFoundError ? ["We couldn't recognise the link you arrived on, so we can't make your report yet. Get in touch and we'll make it for you"] : []),
        ...(isContactDetailsRequiredError ? ["We need an email address or a phone number before we can make your report. Go back and add one, and we'll get started"] : []),
        ...(isUnexpectedError ? ["Something went wrong while we were making your report. Please refresh the page and try again"] : []),
    ];
};
